import { Link } from "react-router-dom";
import { LEGAL } from "./content/legal";
import { useMeta } from "../hooks/useMeta";
import { draftPath } from "./DraftLayout";

function Para({ p }) {
  if (typeof p === "string") return <p className="text-base leading-relaxed text-navy/80">{p}</p>;
  if (p.address) return <address className="not-italic text-base leading-relaxed text-navy">{p.address.map((l) => <div key={l}>{l}</div>)}</address>;
  if (p.sub) return <h3 className="pt-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-navy/60">{p.sub}</h3>;
  if (p.list) return <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-navy/80">{p.list.map((l) => <li key={l.slice(0, 60)}>{l}</li>)}</ul>;
  return (
    <p className="text-base leading-relaxed text-navy/80">
      {p.text}<Link to={draftPath(p.link.to)} className="font-bold text-link hover:underline">{p.link.label}</Link>{p.after}
      {p.link2 && <><Link to={draftPath(p.link2.to)} className="font-bold text-link hover:underline">{p.link2.label}</Link>{p.after2}</>}
    </p>
  );
}

export default function LegalPage({ slug }) {
  const doc = LEGAL[slug];
  useMeta({ title: doc ? `${doc.title} | Smart Marketer Agency` : "Not found", description: doc ? `${doc.title} for Smart Marketer Agency.` : "" });
  if (!doc) return <main data-testid="draft-not-found" className="bg-white"><div className="mx-auto max-w-4xl px-5 py-24 text-center text-2xl font-bold text-navy">Page not found.</div></main>;
  return (
    <main data-testid={`draft-legal-${slug}`}>
      <section className="bg-navy">
        <div className="mx-auto max-w-6xl px-5 py-16 md:py-20">
          <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-pink">Legal</div>
          <h1 className="mt-4 text-4xl font-bold leading-[1.08] text-white sm:text-5xl">{doc.title}</h1>
          {doc.updated && <p className="mt-5 text-sm text-white/60">{doc.updated}</p>}
        </div>
      </section>
      <section className="bg-white">
        <div className="mx-auto grid max-w-6xl gap-12 px-5 py-14 lg:grid-cols-[220px_1fr] md:py-20">
          <nav data-testid="legal-nav" className="hidden lg:block">
            <div className="sticky top-28 flex flex-col gap-2 text-sm">
              {Object.entries(LEGAL).map(([k, v]) => (
                <Link key={k} to={draftPath(`/${k}`)} data-testid={`legal-nav-${k}`} className={`rounded-lg px-3 py-2 ${k === slug ? "bg-fog font-bold text-navy" : "text-navy/60 hover:text-navy"}`}>{v.title}</Link>
              ))}
            </div>
          </nav>
          <article className="max-w-3xl space-y-10">
            {doc.sections.map((s, i) => (
              <section key={s.heading || i} className="space-y-4">
                {s.heading && <h2 className="text-2xl font-bold text-navy">{s.heading}</h2>}
                {s.body.map((p, j) => <Para key={j} p={p} />)}
              </section>
            ))}
          </article>
        </div>
      </section>
    </main>
  );
}
